module.exports = __webpack_public_path__ + "img/modal2.b5c09ce7.png";